module.exports = __webpack_public_path__ + "img/deonde-icon.f1eed54d.svg";